import React from "react";
import { Link } from "react-router-dom";
import FluxiLogo from "../assets/svg/FluxiLogo.svg";

const MobileHeader = () => {
  return (
    <div className="md:hidden fixed top-0 left-0 w-full z-50 bg-white shadow-md border-b border-gray-200">
      {/* SVG Header */}
      <div className="w-full flex justify-center items-center py-1 bg-white shadow-md">
        <img src={FluxiLogo} alt="Fluxi Logo" className="pl-3 h-auto" />{" "}
      </div>
    </div>
  );
};

export default MobileHeader;
